namespace GeniuzPOS.Administration {
    export class PsFuncLevelColumns {
        static columnsKey = 'Administration.PsFuncLevel';
    }
}
